import { Prompt } from "@/types/app/prompt";
import { FileLabelWithPopover } from "@components/library/Entities/FileLabelWithPopover";
import { PageSectionHeader } from "@components/library/PageSectionHeader";
import { JSONViewer } from "@components/llama/Code/JSONViewer";
import { isEmpty, startCase } from "lodash";

export type ToolDetailsProps = Pick<Prompt, "tools" | "linked_tools">; // TODO(v5): Add linked_tools.

export const ToolDetails = ({ tools, linked_tools: linkedTools }: ToolDetailsProps) => {
  if (isEmpty(tools) && isEmpty(linkedTools)) {
    return null;
  }

  return (
    <div className="mt-24">
      <PageSectionHeader title={"Tools"} size="sm" />
      <div className={"flex flex-col gap-6"}>
        {linkedTools?.map((tool, index) => (
          <div key={tool.id} className="">
            <FileLabelWithPopover fileId={tool.id} displayFile size={20} versionId={tool.version_id} />
          </div>
        ))}

        {tools?.map((tool, index) => (
          <div key={index} className="rounded border border-oldgray-400 bg-oldgray-200 px-8 py-8 text-11-16">
            <div className="px-4 py-4 text-12-14 font-bold text-oldgray-600">{startCase(tool.name)}</div>
            <div key={index} className="text-12-14">
              <JSONViewer
                value={{
                  name: tool.name,
                  description: tool?.description,
                  parameters: tool?.parameters,
                }}
                defaultInspectDepth={0}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
